import { render, staticRenderFns } from "./PointExpireBatchDetailModal.vue?vue&type=template&id=6a981692&scoped=true"
import script from "./PointExpireBatchDetailModal.vue?vue&type=script&lang=js"
export * from "./PointExpireBatchDetailModal.vue?vue&type=script&lang=js"
import style0 from "./PointExpireBatchDetailModal.vue?vue&type=style&index=0&id=6a981692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a981692",
  null
  
)

export default component.exports